import { render, staticRenderFns } from "./DigitalGym.vue?vue&type=template&id=e392d208"
import script from "./DigitalGym.vue?vue&type=script&lang=js"
export * from "./DigitalGym.vue?vue&type=script&lang=js"
import style0 from "./DigitalGym.vue?vue&type=style&index=0&id=e392d208&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports